function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { onResponse } from 'http-client';
import get from 'lodash/get';
export var timeout = function timeout(milliseconds) {
  return function (fetch, input) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return new Promise(function (resolve, reject) {
      fetch(input, options).then(resolve);
      setTimeout(function () {
        return reject({
          error: {
            name: 'timeoutError',
            timeout: milliseconds
          }
        });
      }, milliseconds);
    });
  };
};

var getErrorCode = function getErrorCode(_ref) {
  var code = _ref.code,
      error = _ref.error,
      status = _ref.status;
  return code || error && (error.message || error.type) || error || status;
};

export var handleKjson = function handleKjson() {
  return onResponse(function (response) {
    var data = response.response || {};

    if (!response.ok || data.status === 'fail' || data.error) {
      var error = new Error("API response contains error. Code: ".concat(getErrorCode(data)));
      error.status = Number(response.status) || Number(data.code) || null;
      error.response = _objectSpread({}, data, {
        name: 'requestError',
        type: get(data, 'error.type', null),
        code: get(data, 'error.code', null),
        cause: get(data, 'error.cause', {}),
        message: get(data, 'error.reason') || get(data, 'error.message', '')
      });
      throw error;
    }

    return response;
  });
};